/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'add': {
    width: 200,
    height: 200,
    viewBox: '0 0 200 200',
    data: '<path pid="0" fill-rule="evenodd" opacity=".6" d="M111.76 88.24V11.76C111.76 4.71 107.06 0 100 0S88.24 4.71 88.24 11.76v76.48H11.76C4.71 88.24 0 92.94 0 100s4.71 11.76 11.76 11.76h76.48v76.48c0 7.05 4.7 11.76 11.76 11.76s11.76-4.71 11.76-11.76v-76.48h76.48c7.05 0 11.76-4.7 11.76-11.76s-4.71-11.76-11.76-11.76h-76.48z" _fill="#000"/>'
  }
})
